export function InlineField({title, element}){
    return (
        <div className="inlineField"><h6>{title}</h6>{element}</div>
    )
}